/**
 * util
 */

import sleep from "./sleep";
import deepFreeze from "./deepFreeze";

export default {
  sleep,
  deepFreeze,

  // Window userAgent
  UA() {
    return window.navigator.userAgent;
  },

  // Checks if in the APP
  isAPP() {
    return /n8Web/i.test(this.UA());
  },

  // Checks if in the uni-app web-view
  isUniWebView() {
    return /jzUni/i.test(this.UA());
  },

  // Checks if in the wx web-view
  isWxWebView() {
    return /miniProgram/i.test(this.UA());
  },

  // Checks if in the IOS
  isIOS() {
    return /iphone|ipad|ipod/i.test(this.UA());
  },

  // Checks if in the Android
  isAndroid() {
    return /android/i.test(this.UA());
  },

  // Checks if in the Weixin
  isWeixin() {
    return /MicroMessenger/i.test(this.UA());
  },

  // IOS handlers
  runIOS(data, fallback = () => {}, method = "N8WebView") {
    if (!this.isIOS()) return false;

    const { webkit } = window;
    const handler = webkit && webkit.messageHandlers[method];
    if (!handler) return fallback();

    return handler.postMessage(data);
  },

  // Android handlers
  runAndroid(data, method = "", callback = "", fallback = () => {}) {
    if (!this.isAndroid()) return false;

    const { android } = window;
    if (!android) return fallback();

    return android[method](JSON.stringify(data), callback);
  }
};



// WEBPACK FOOTER //
// ./src/common/util/index.ts